export class RequestSourceModel{
    sys?:string;
}